import * as date from 'date-fns';

export function dataAttuale() {
  return date.format(new Date(), 'yyyy-MM-dd');
}

export function dataOraAttuale() {
  return date.format(new Date(), "yyyy-MM-dd'T'HH:mm");
}
